export default __webpack_public_path__ + "static/media/tilschweiger.7fc86e49.png";